export default __webpack_public_path__ + "static/media/less-than.e1bc1782.svg";